import LegalLayout, { H2, P, UL } from "@/components/legal/LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="Terms & Conditions"
      updated="January 20, 2026"
      testid="terms-page"
    >
      <P>
        These Terms &amp; Conditions ("Terms") govern your access to and use of the Qovarix website,
        closed beta waitlist, documentation, and any services offered by BlockNexa Labs
        (collectively, the "Service"). By accessing the Service you agree to be bound by these Terms.
        If you do not agree, do not use the Service.
      </P>

      <H2>1. Eligibility</H2>
      <P>
        The Service is intended for users who are at least 18 years old and legally permitted to
        access decentralized finance protocols in their jurisdiction. You are solely responsible for
        determining whether use of Qovarix is lawful where you reside.
      </P>

      <H2>2. Closed Beta Access</H2>
      <P>
        Qovarix is currently offered through a closed beta program. Submitting your email to the
        waitlist does not guarantee access. Access is granted at our sole discretion and may be
        revoked at any time. Beta features may be incomplete, change without notice, or be removed.
      </P>

      <H2>3. Non-Custodial Nature</H2>
      <P>
        Qovarix is a non-custodial protocol. You retain full control of your wallet and private keys
        at all times. BlockNexa Labs never takes custody of user funds. You are solely responsible
        for the security of your wallet, seed phrase, and any credentials associated with your
        account.
      </P>

      <H2>4. No Investment Advice</H2>
      <P>
        Nothing on Qovarix constitutes investment, financial, legal, or tax advice. Prediction
        markets involve substantial risk, including possible loss of the entire amount committed.
        You should consult a qualified professional before making any financial decision.
      </P>

      <H2>5. Acceptable Use</H2>
      <UL>
        <li>Do not use the Service in violation of any applicable law or regulation.</li>
        <li>Do not attempt to exploit, reverse engineer, or disrupt the Service or its smart contracts.</li>
        <li>Do not submit false or misleading information, including fake waitlist emails.</li>
        <li>Do not use the Service to launder funds or finance illegal activity.</li>
      </UL>

      <H2>6. Intellectual Property</H2>
      <P>
        The Qovarix name, logo, brand assets, whitepaper, and interface design are the property of
        BlockNexa Labs. Smart contract source code, where open-sourced, is licensed under its
        respective license. All other rights are reserved.
      </P>

      <H2>7. Disclaimers</H2>
      <P>
        The Service is provided on an "as is" and "as available" basis without warranties of any
        kind, express or implied. We do not warrant that the Service will be uninterrupted,
        error-free, or secure. Blockchain networks are independent of Qovarix and subject to
        congestion, forks, and other risks beyond our control.
      </P>

      <H2>8. Limitation of Liability</H2>
      <P>
        To the maximum extent permitted by law, BlockNexa Labs and its affiliates shall not be
        liable for any indirect, incidental, special, consequential, or punitive damages arising out
        of or relating to your use of the Service, including loss of funds, profits, or data.
      </P>

      <H2>9. Changes</H2>
      <P>
        We may update these Terms from time to time. Continued use of the Service after changes
        become effective constitutes acceptance of the updated Terms. Material changes will be
        reflected in the "Last updated" date above.
      </P>

      <H2>10. Contact</H2>
      <P>
        For questions about these Terms, contact BlockNexa Labs at{" "}
        <a href="mailto:contact@blocknexalabs.com" className="text-[#00F0FF] hover:underline">
          contact@blocknexalabs.com
        </a>
        .
      </P>
    </LegalLayout>
  );
}
